import React, { useState, useEffect } from "react";
import { Ic } from "../constants/icons";
import { GOLD, getAC } from "../constants/theme";
import { MEMBERS, LEADERBOARD } from "../utils/community";
import { supabase } from "../../supabaseClient";

export function MemberCard({name,anchorRef,C,dark,onClose}){
  const m = MEMBERS[name];
  // Derive contributor status from this user's post activity (last 30 days).
  // Hooks must run unconditionally (rules-of-hooks) — keep them above any
  // early-return so the call order is stable across renders.
  const [contrib, setContrib] = useState(null);
  useEffect(() => {
    if (!m) return;
    (async () => {
      // Look up the user by name → get post count
      const { data: profile } = await supabase
        .from("profiles").select("id, first_name, last_name")
        .or(`first_name.ilike.${name.split(" ")[0]}%,last_name.ilike.${name.split(" ").slice(-1)[0]}%`)
        .limit(5);
      const match = (profile || []).find(p => `${p.first_name} ${p.last_name}`.trim().toLowerCase() === name.toLowerCase());
      if (!match) return;
      const { count } = await supabase.from("community_posts")
        .select("*", { count: "exact", head: true })
        .eq("author_id", match.id)
        .gte("created_at", new Date(Date.now() - 30*86400000).toISOString());
      if (count && count > 0) setContrib({ streak: count });
    })();
  }, [name, m]);
  if (!m) return null;
  const ac=getAC(name);
  const rect=anchorRef.current?.getBoundingClientRect();
  const top=rect?Math.min(rect.bottom+8,window.innerHeight-230):100;
  const left=rect?Math.min(rect.left,window.innerWidth-280):100;
  return (
    <div className="member-card" onClick={e=>e.stopPropagation()} style={{position:"fixed",zIndex:1000,background:dark?"linear-gradient(180deg,#171717,#111111)":"#fff",border:`1px solid ${dark?"rgba(255,255,255,0.08)":C.border}`,borderRadius:14,padding:20,width:262,boxShadow:dark?"0 20px 60px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.04)":"0 12px 40px rgba(0,0,0,0.14)",top,left}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14}}>
        <div style={{display:"flex",gap:12,alignItems:"center"}}>
          <div style={{width:46,height:46,borderRadius:"50%",background:ac,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,fontWeight:800,color:"#fff",boxShadow:`0 3px 12px ${ac}66`}}>{m.initials}</div>
          <div>
            <div style={{fontSize:15,fontWeight:800,color:dark?"#F2F2F2":C.text}}>{name}</div>
            <div style={{fontSize:12,color:dark?"#888":C.textDim,marginTop:2,display:"flex",alignItems:"center",gap:4}}><span style={{fontSize:13}}>{m.flag}</span>{m.loc}</div>
          </div>
        </div>
        <span className="btn" onClick={onClose}><Ic.Close c={dark?"#666":C.textDim} s={11}/></span>
      </div>
      <div style={{fontSize:13,color:dark?"#AAA":C.textMid,lineHeight:1.6,marginBottom:14}}>{m.bio}</div>
      {contrib&&contrib.streak>=1&&(
        <div style={{display:"flex",flexWrap:"wrap",gap:5,marginBottom:12}}>
          <div style={{display:"flex",alignItems:"center",gap:4,fontSize:10,fontWeight:700,color:GOLD,background:GOLD+"18",border:`1px solid ${GOLD}44`,borderRadius:14,padding:"3px 9px"}}>
            📹 Contributor
          </div>
          {contrib.streak>=3&&(
            <div style={{display:"flex",alignItems:"center",gap:4,fontSize:10,fontWeight:700,color:"#C9A84C",background:"#C9A84C18",border:"1px solid #C9A84C44",borderRadius:14,padding:"3px 9px"}}>
              🎓 Elite
            </div>
          )}
          {Math.floor(contrib.streak/4)>0&&(
            <div style={{display:"flex",alignItems:"center",gap:3,fontSize:10,fontWeight:700,color:"#E06050",background:"#E0605018",border:"1px solid #E0605044",borderRadius:14,padding:"3px 9px"}}>
              {Array.from({length:Math.min(Math.floor(contrib.streak/4),3)}).map((_,i)=><span key={i}>🔥</span>)}
            </div>
          )}
        </div>
      )}
      <div style={{display:"flex",gap:6,marginBottom:14}}>
        {m.ig&&<div style={{display:"flex",alignItems:"center",gap:5,fontSize:12,color:dark?"#888":C.textDim,background:dark?"rgba(255,255,255,0.06)":C.bgHover,padding:"5px 10px",borderRadius:7,fontWeight:600}}><Ic.IG c={dark?"#888":C.textDim} s={12}/>@{m.ig}</div>}
        {m.tw&&<div style={{display:"flex",alignItems:"center",gap:5,fontSize:12,color:dark?"#888":C.textDim,background:dark?"rgba(255,255,255,0.06)":C.bgHover,padding:"5px 10px",borderRadius:7,fontWeight:600}}><Ic.TW c={dark?"#888":C.textDim} s={11}/>@{m.tw}</div>}
      </div>
      <div style={{display:"flex",justifyContent:"space-between",paddingTop:12,borderTop:`1px solid ${dark?"rgba(255,255,255,0.06)":C.border}`}}>
        {[["Posts",m.posts],["Points",LEADERBOARD.find(l=>l.n===name)?.pts??"–"],["Rank","#"+(LEADERBOARD.findIndex(l=>l.n===name)+1)||"–"]].map(([l,v])=>(
          <div key={l} style={{textAlign:"center"}}>
            <div style={{fontSize:18,fontWeight:800,color:dark?GOLD:"#111"}}>{v}</div>
            <div style={{fontSize:11,color:dark?"#666":C.textDim}}>{l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
